<!-- ----------------------------------------------- -->
<template>
  <v-card class="com-pc-card tm-pc-curt-card">
    <v-row class="com-pc-card-header" v-show="pcPanelMode">
      <div class="com-pc-card-title">
        {{ text.title }} {{ tmStageList.curt.obsTime }}
      </div>
    </v-row>
    <v-row class="com-pc-card-contents justify-space-around flex-nowrap" no-gutters>
      <v-col class="d-flex justify-center align-center">
        <v-sheet
          outlined
          v-bind:class="pcPanelModeUpstreamClass"
          v-if="tmStageList.curt.category.upStgParam"
        >
          <v-col class="pa-0">
            <v-row no-gutters>
              <v-btn
                class="tm-pc-txt-btn"
                text
                tile
                @click="clickObsList(tmStageList.curt.category.upStgParam)"
              >
                <v-icon class="tm-pc-transition_btn"
                  >arrow_left</v-icon
                >
                {{ tmStageList.curt.category.upObsTitle }}
              </v-btn>
            </v-row>
            <v-divider class="tm-pc-divider"></v-divider>
            <v-row no-gutters>
              <div
                class="tm-pc-current-label tm-pc-stg-fld-color"
                :stg-fld-color="upFldColor"
                v-if="
                  stgMode === '1' && tmStageList.curt.category.upDspFlg === 1
                "
              >
                {{ tmStageList.curt.category.stgHght.title }}
              </div>
              <div
                class="tm-pc-current-label tm-pc-stg-fld-color"
                :stg-fld-color="upFldColor"
                v-else
              >
                {{ tmStageList.curt.category.stg.title }}
              </div>
            </v-row>
            <v-divider></v-divider>
            <v-row no-gutters justify="center">
              <div class="card">
                <span
                  v-if="
                    stgMode === '1' && tmStageList.curt.category.upDspFlg === 1
                  "
                  >{{ tmStageList.curt.category.upStgHght.upObsValue }}</span
                >
                <span v-else>{{
                  tmStageList.curt.category.upStg.upObsValue
                }}</span>
                <span>{{ tmStageList.curt.category.upObsUnit }}</span>
                <template
                  v-if="
                    stgMode === '1' &&
                      tmStageList.curt.category.upDspFlg === 1 &&
                      tmStageList.curt.category.upStgHght.upObsValueValid
                  "
                >
                  <v-icon
                    v-if="tmStageList.curt.category.upStg10mChg > 0"
                    class="state icon-arrow-up"
                    >arrow_upward</v-icon
                  >
                  <v-icon
                    v-else-if="tmStageList.curt.category.upStg10mChg === 0"
                    class="state icon-arrow-down"
                    >arrow_forward</v-icon
                  >
                  <v-icon
                    v-else-if="tmStageList.curt.category.upStg10mChg < 0"
                    class="state icon-arrow-down"
                    >arrow_downward</v-icon
                  >
                </template>
                <template
                  v-else-if="tmStageList.curt.category.upStg.upObsValueValid"
                >
                  <v-icon
                    v-if="tmStageList.curt.category.upStg10mChg > 0"
                    class="state icon-arrow-up"
                    >arrow_upward</v-icon
                  >
                  <v-icon
                    v-else-if="tmStageList.curt.category.upStg10mChg === 0"
                    class="state icon-arrow-down"
                    >arrow_forward</v-icon
                  >
                  <v-icon
                    v-else-if="tmStageList.curt.category.upStg10mChg < 0"
                    class="state icon-arrow-down"
                    >arrow_downward</v-icon
                  >
                </template>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-if="tmStageList.curt.category.isAbnrmlUp"
                      v-on="on"
                      class="icon-qmflg"
                      >warning</v-icon
                    >
                  </template>
                  <span>{{ text.abnormal }}</span>
                </v-tooltip>
              </div>
            </v-row>
          </v-col>
        </v-sheet>
      </v-col>

      <v-col>
        <v-sheet outlined v-bind:class="pcPanelModeCurrentClass">
          <v-col class="pa-0">
            <v-row no-gutters>
              <div
                class="tm-pc-current-label tm-pc-stg-fld-color"
                :stg-fld-color="fldColor"
                :label-height="labelHeight"
                v-if="stgMode === '1' && tmStageList.curt.category.dspFlg === 1"
              >
                {{ tmStageList.curt.category.stgHght.title }}
              </div>
              <div
                class="tm-pc-current-label tm-pc-stg-fld-color"
                :stg-fld-color="fldColor"
                :label-height="labelHeight"
                v-else
              >
                {{ tmStageList.curt.category.stg.title }}
              </div>
            </v-row>
            <v-row
              no-gutters
              v-show="showStgOvlvlNm(tmStageList.curt.category.stgOvlvl)"
            >
              <div
                class="tm-pc-current-ovlvl-label tm-pc-stg-fld-color"
                :stg-fld-color="fldColor"
              >
                {{ stgOvlvlNm }}
              </div>
            </v-row>
            <v-divider></v-divider>
            <v-row no-gutters justify="center">
              <div class="card">
                <span
                  v-if="
                    stgMode === '1' && tmStageList.curt.category.dspFlg === 1
                  "
                  >{{ tmStageList.curt.category.stgHght.currentObsValue }}</span
                >
                <span v-else>{{
                  tmStageList.curt.category.stg.currentObsValue
                }}</span>

                <span>{{ tmStageList.curt.category.currentObsUnit }}</span>
                <template
                  v-if="
                    stgMode === '1' &&
                      tmStageList.curt.category.dspFlg === 1 &&
                      tmStageList.curt.category.stgHght.currentObsValueValid
                  "
                >
                  <v-icon
                    v-if="tmStageList.curt.category.stg10mChg > 0"
                    class="state icon-arrow-up-crt"
                    >arrow_upward</v-icon
                  >
                  <v-icon
                    v-else-if="tmStageList.curt.category.stg10mChg === 0"
                    class="state icon-arrow-down-crt"
                    >arrow_forward</v-icon
                  >
                  <v-icon
                    v-else-if="tmStageList.curt.category.stg10mChg < 0"
                    class="state icon-arrow-down-crt"
                    >arrow_downward</v-icon
                  >
                </template>
                <template
                  v-else-if="tmStageList.curt.category.stg.currentObsValueValid"
                >
                  <v-icon
                    v-if="tmStageList.curt.category.stg10mChg > 0"
                    class="state icon-arrow-up-crt"
                    >arrow_upward</v-icon
                  >
                  <v-icon
                    v-else-if="tmStageList.curt.category.stg10mChg === 0"
                    class="state icon-arrow-down-crt"
                    >arrow_forward</v-icon
                  >
                  <v-icon
                    v-else-if="tmStageList.curt.category.stg10mChg < 0"
                    class="state icon-arrow-down-crt"
                    >arrow_downward</v-icon
                  >
                </template>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-if="tmStageList.curt.category.isAbnrml"
                      v-on="on"
                      class="icon-qmflg"
                      >warning</v-icon
                    >
                  </template>
                  <span>{{ text.abnormal }}</span>
                </v-tooltip>
              </div>
            </v-row>
          </v-col>
        </v-sheet>
      </v-col>

      <v-col class="d-flex justify-center align-center">
        <v-sheet
          outlined
          v-bind:class="pcPanelModeDownstreamClass"
          v-if="tmStageList.curt.category.dwStgParam"
        >
          <v-col class="pa-0">
            <v-row no-gutters>
              <v-btn
                class="tm-pc-txt-btn"
                text
                tile
                @click="clickObsList(tmStageList.curt.category.dwStgParam)"
              >
                {{ tmStageList.curt.category.downObsTitle }}
                <v-icon class="transition_btn"
                  >arrow_right</v-icon
                >
              </v-btn>
            </v-row>
            <v-divider></v-divider>
            <v-row no-gutters>
              <div
                class="tm-pc-current-label tm-pc-stg-fld-color"
                :stg-fld-color="dwFldColor"
                v-if="
                  stgMode === '1' && tmStageList.curt.category.dwDspFlg === 1
                "
              >
                {{ tmStageList.curt.category.stgHght.title }}
              </div>
              <div
                class="tm-pc-current-label tm-pc-stg-fld-color"
                :stg-fld-color="dwFldColor"
                v-else
              >
                {{ tmStageList.curt.category.stg.title }}
              </div>
            </v-row>
            <v-divider></v-divider>
            <v-row no-gutters justify="center">
              <div class="card">
                <span
                  v-if="
                    stgMode === '1' && tmStageList.curt.category.dwDspFlg === 1
                  "
                  >{{ tmStageList.curt.category.dwStgHght.downObsValue }}</span
                >
                <span v-else>{{
                  tmStageList.curt.category.dwStg.downObsValue
                }}</span>

                <span>{{ tmStageList.curt.category.downObsUnit }}</span>
                <template
                  v-if="
                    stgMode === '1' &&
                      tmStageList.curt.category.dwDspFlg === 1 &&
                      tmStageList.curt.category.dwStgHght.downObsValueValid
                  "
                >
                  <v-icon
                    v-if="tmStageList.curt.category.dwStg10mChg > 0"
                    class="state icon-arrow-up"
                    >arrow_upward</v-icon
                  >
                  <v-icon
                    v-else-if="tmStageList.curt.category.dwStg10mChg === 0"
                    class="state icon-arrow-down"
                    >arrow_forward</v-icon
                  >
                  <v-icon
                    v-else-if="tmStageList.curt.category.dwStg10mChg < 0"
                    class="state icon-arrow-down"
                    >arrow_downward</v-icon
                  >
                </template>
                <template
                  v-else-if="tmStageList.curt.category.dwStg.downObsValueValid"
                >
                  <v-icon
                    v-if="tmStageList.curt.category.dwStg10mChg > 0"
                    class="state icon-arrow-up"
                    >arrow_upward</v-icon
                  >
                  <v-icon
                    v-else-if="tmStageList.curt.category.dwStg10mChg === 0"
                    class="state icon-arrow-down"
                    >arrow_forward</v-icon
                  >
                  <v-icon
                    v-else-if="tmStageList.curt.category.dwStg10mChg < 0"
                    class="state icon-arrow-down"
                    >arrow_downward</v-icon
                  >
                </template>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-if="tmStageList.curt.category.isAbnrmlDw"
                      v-on="on"
                      class="icon-qmflg"
                      >warning</v-icon
                    >
                  </template>
                  <span>{{ text.abnormal }}</span>
                </v-tooltip>
              </div>
            </v-row>
          </v-col>
        </v-sheet>
      </v-col>
    </v-row>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [PC]水位 最新観測値カード
 * TmStageCurt.vue
 * @author ILUKE
 */

import mixin from "./../../lib/mixin.js";
export default {
  name: "tm-stage-curt",
  mixins: [mixin],
  data() {
    return {
      /** 文字列リソース */
      text: {
        title: "最新観測値",
        abnormal: "異常のおそれあり",
      },
      upFldColor: "normal",
      fldColor: "normal",
      dwFldColor: "normal",
      labelHeight: "other",
      stgOvlvlNm: "",
    };
  },
  computed: {
    /**
     * 通常水位情報 取得
     */
    tmStageList: {
      get() {
        return this.$store.state.Telemeter.selectedTm;
      },
    },
    /**
     * 水位表示
     */
    stgMode: {
      get() {
        return this.$store.state.app.stgMode;
      },
    },
    /** 水防団モード*/
    isFldCtl: {
      get() {
        return this.$store.getters["app/isFldCtl"];
      },
    },
    /*フレーム拡大時のclass設定(上流)*/
    pcPanelModeUpstreamClass: {
      get() {
        // if (this.$store.state.app.pcPanelMode) {
        //   return "tm-pc-upstream-card not-margin";
        // } else {
          return "tm-pc-upstream-card";
        // }
      },
    },
    /*フレーム拡大時のclass設定*/
    pcPanelModeCurrentClass: {
      get() {
        // if (this.$store.state.app.pcPanelMode) {
        //   return "tm-pc-current-stg-data-box not-margin";
        // } else {
          return "tm-pc-current-stg-data-box";
        // }
      },
    },
    /*フレーム拡大時のclass設定(下流)*/
    pcPanelModeDownstreamClass: {
      get() {
        // if (this.$store.state.app.pcPanelMode) {
        //   return "tm-pc-downstream-card not-margin";
        // } else {
          return "tm-pc-downstream-card";
        // }
      },
    },
    /** フレームの拡大・縮小判定用 */
    pcPanelMode: {
      get() {
        return this.$store.state.app.pcPanelMode;
      },
    },
  },
  mounted() {
    /** 水位超過 着色 */
    const crntfld = this.tmStageList.curt.category;
    this.fldColor = this.setFloodColor(
      crntfld.stgOvlvl,
      crntfld.stgCcd,
      crntfld.rsrvStg,
      crntfld.warnStg,
      crntfld.spclWarnStg,
      crntfld.dngStg
    );
    this.upFldColor = this.setFloodColor(
      crntfld.upStgOvlvl,
      crntfld.upStgCcd,
      crntfld.upRsrvStg,
      crntfld.upWarnStg,
      crntfld.upSpclWarnStg,
      crntfld.upDngStg
    );
    this.dwFldColor = this.setFloodColor(
      crntfld.dwStgOvlvl,
      crntfld.dwStgCcd,
      crntfld.dwRsrvStg,
      crntfld.dwWarnStg,
      crntfld.dwSpclWarnStg,
      crntfld.dwDngStg
    );
    this.labelHeight = this.setLablHeight(crntfld.stgOvlvl);
    this.stgOvlvlNm = this.setStgOvlvlNm(crntfld.stgOvlvl);
  },
  methods: {
    /** 上流・下流観測所画面遷移 */
    clickObsList(stgParam) {
      // パネル拡大モードOFF
      // this.$store.commit("app/setPcPanelMode", false);
      // 選択中テレメータ情報を設定
      this.$store.commit("Telemeter/setSelectedTmParam", {
        ofcCd: stgParam[0],
        itmkndCd: stgParam[1],
        obsCd: stgParam[2],
      });
      // 画面遷移
      this.routerPushTm("/pc/tm");
    },
    /** 水位超過 着色 */
    setFloodColor(ovlvl, ccd, rsrvStg, warnStg, spclWarnStg, dngStg) {
      if (ovlvl === 90) {
        // 氾濫発生
        return "occurrence";
      } else if (
        // 基準水位未設定
        rsrvStg === null &&
        warnStg === null &&
        spclWarnStg === null &&
        dngStg === null
      ) {
        return "notset";
      } else if (ovlvl === 80 || ovlvl === 70) {
        // 氾濫危険水位超過
        return "danger";
      } else if (ovlvl === 60 || ovlvl === 50) {
        // 避難判断水位超過
        return "refuge";
      } else if (ovlvl === 40 || ovlvl === 30 || ovlvl === 20) {
        // 氾濫注意水位超過
        return "caution";
      } else if (this.isFldCtl && ovlvl === 10) {
        // 水防団モードかつ、水防団待機水位超過
        return "standbyed";
      } else if (ccd === 190 || ccd === 160) {
        // 欠測
        return "missing";
      } else if (ccd === 140) {
        // 閉局
        return "close";
      } else {
        // 平常
        return "normal";
      }
    },
    /** ラベルの高さを設定する */
    setLablHeight(stgOvlvl) {
      if (
        (this.isFldCtl && 10 <= stgOvlvl && stgOvlvl <= 90) ||
        (!this.isFldCtl && 30 <= stgOvlvl && stgOvlvl <= 90)
      ) {
        return "stgOvlvl";
      }
      return "other";
    },
    /** 超過基準水位名を表示するか */
    showStgOvlvlNm(stgOvlvl) {
      if (
        (this.isFldCtl && 10 <= stgOvlvl && stgOvlvl <= 90) ||
        (!this.isFldCtl && 30 <= stgOvlvl && stgOvlvl <= 90)
      ) {
        return true;
      }
      return false;
    },
    /**
     * 超過基準水位名の取得
     */
    setStgOvlvlNm(stgOvlvl) {
      if (stgOvlvl === 90) {
        return "氾濫開始水位超過(Lv5相当)";
      } else if (stgOvlvl === 80 || stgOvlvl === 70) {
        return "氾濫危険水位超過(Lv4相当)";
      } else if (stgOvlvl === 60 || stgOvlvl === 50) {
        return "避難判断水位超過(Lv3相当)";
      } else if (stgOvlvl === 40 || stgOvlvl === 30 || stgOvlvl === 20) {
        return "氾濫注意水位超過(Lv2相当)";
      } else if (this.isFldCtl && stgOvlvl === 10) {
        return "水防団待機水位超過(Lv1相当)";
      }
      return "";
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
.not-margin {
  width: 0px;
  width: 100%;
  margin: 0px;
  margin-top: 12px;
}
</style>
